/**
 * Szerepkörök megjelenítése — egy helyen.
 *
 * Korábban ez a négy szín-térkép négy külön fájlban élt (Navbar, UserPanel,
 * AdminPanel, UserDetailModal), és egy új szerepkörnél mindegyiket meg kellett
 * volna találni. A backend párja: `backend/src/utils/roles.js`.
 */

export const ROLE_BADGE = {
  owner:  'bg-brand-500/15 text-brand-200 border-brand-400/25',
  admin:  'bg-amber-500/15 text-amber-300 border-amber-400/25',
  tester: 'bg-teal-500/15 text-teal-300 border-teal-400/25',
  user:   'bg-white/[0.05] text-gray-400 border-white/[0.08]',
};

export const roleBadgeClass = (role) => ROLE_BADGE[role] || ROLE_BADGE.user;

/**
 * Amit az owner ki tud osztani. Az `owner` szándékosan hiányzik: ownert csak
 * közvetlenül az adatbázisban lehet csinálni.
 */
export const ASSIGNABLE_ROLES = [
  { id: 'admin',  label: 'Admin',  hint: 'Full staff access' },
  { id: 'tester', label: 'Tester', hint: 'Lifetime license, no staff access' },
  { id: 'user',   label: 'User',   hint: 'Normal account' },
];
